import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Modal,
    TextField,
    Select,
    MenuItem,
    Button,
    FormControl,
    InputLabel,
    Grid,
    Paper,
    Snackbar,
    Alert,
} from '@mui/material';
import { Visibility, Add, Close } from '@mui/icons-material';
import axios from 'axios';
import moment from 'moment';


const HorasExtraPage = () => {
    const [empregados, setEmpregados] = useState([]);
    const [selectedEmpregado, setSelectedEmpregado] = useState(null);
    const [horasExtras, setHorasExtras] = useState([]);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [selectedMes, setSelectedMes] = useState(moment().month() + 1);
    const [selectedAno, setSelectedAno] = useState(moment().year());
    const [newHoraExtra, setNewHoraExtra] = useState({
        data: moment().format('YYYY-MM-DD'),
        horas_trabalhadas: '',
        justificativa: '',
    });
    const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
    const [searchTerm, setSearchTerm] = useState('');
    const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local

    useEffect(() => {
        fetchEmpregados();
    }, []);
    


const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
};


    const fetchEmpregados = async () => {
        const token = localStorage.getItem('access');
        try {
            const response = await axios.get(`${apiBaseURL}/api/empregados/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setEmpregados(response.data);
        } catch (error) {
            console.error('Erro ao buscar empregados:', error);
            showAlert('Erro ao carregar empregados.', 'error');
        }
    };

    const fetchHorasExtras = async (empregadoId, mes, ano) => {
        const token = localStorage.getItem('access');
        try {
            const response = await axios.get(
                `${apiBaseURL}/api/horas-extras/?empregado=${empregadoId}&mes=${mes}&ano=${ano}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            // Verifica o payload antes de aplicar o filtro
        console.log('Response payload (sem filtrar):', response.data);

        // Filtra o payload para garantir que as horas extra correspondem ao mês e ano selecionados
        const horasFiltradas = response.data.filter(hora => {
            const dataHora = new Date(hora.data);
            return dataHora.getMonth() + 1 === mes && dataHora.getFullYear() === ano;
        });

        console.log('Response payload (filtrado):', horasFiltradas);

        // Atualiza o estado com os dados filtrados
        setHorasExtras(horasFiltradas);
    } catch (error) {
        console.error('Erro ao buscar horas extras:', error);
        showAlert('Erro ao carregar horas extras.', 'error');
    }
};

    const handleOpenViewModal = (empregado) => {
        setSelectedEmpregado(empregado);
        setSelectedMes(moment().month() + 1);
        setSelectedAno(moment().year());
        setHorasExtras([]);
        setOpenViewModal(true);
        fetchHorasExtras(empregado.id, moment().month() + 1, moment().year());
    };

    const handleOpenAddModal = (empregado) => {
        setSelectedEmpregado(empregado);
        setNewHoraExtra({
            data: moment().format('YYYY-MM-DD'),
            horas_trabalhadas: '',
            justificativa: '',
        });
        setOpenAddModal(true);
    };

    const handleCloseModals = () => {
        setOpenViewModal(false);
        setOpenAddModal(false);
        setSelectedEmpregado(null);
        setHorasExtras([]);
    };

    const handleMesChange = (event) => {
        const mes = event.target.value;
        setSelectedMes(mes);
        if (selectedEmpregado) {
            fetchHorasExtras(selectedEmpregado.id, mes, selectedAno);
        }
    };

    const handleAnoChange = (event) => {
        const ano = event.target.value;
        setSelectedAno(ano);
        if (selectedEmpregado) {
            fetchHorasExtras(selectedEmpregado.id, selectedMes, ano);
        }
    };

    const handleNewHoraExtraChange = (event) => {
        const { name, value } = event.target;
        setNewHoraExtra((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleAddHoraExtra = async () => {
        const token = localStorage.getItem('access');
        if (!newHoraExtra.data || !newHoraExtra.horas_trabalhadas) {
            showAlert('Por favor, preencha todos os campos obrigatórios.', 'warning');
            return;
        }
    
        // Log the payload that will be sent to the API
        const payload = {
            empregado: selectedEmpregado.id,  // Change to empregado_id
            data: newHoraExtra.data,
            horas_trabalhadas: parseFloat(newHoraExtra.horas_trabalhadas),
            justificativa: newHoraExtra.justificativa,
            aprovado_por: null,  // Assuming this will be set later
            data_aprovacao: null,  // Assuming this will be set later
        };
        console.log('Payload to be sent:', payload);
    
        try {
            await axios.post(
                `${apiBaseURL}/api/horas-extras/`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            showAlert('Hora extra adicionada com sucesso!', 'success');
            setOpenAddModal(false);
            fetchHorasExtras(selectedEmpregado.id, selectedMes, selectedAno);
        } catch (error) {
            console.error('Erro ao adicionar hora extra:', error.response ? error.response.data : error.message);
            showAlert('Erro ao adicionar hora extra.', 'error');
        }
    };
    

    const showAlert = (message, severity) => {
        setAlert({ open: true, message, severity });
    };

    const handleCloseAlert = () => {
        setAlert({ ...alert, open: false });
    };

    return (
        
            <Box sx={{ mt: 4 }}>
                <Typography variant="h4" gutterBottom>
                    Gestão de Horas Extras
                </Typography>
                <Paper sx={{ p: 2 }}>
                <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Nome Completo</TableCell>
                        <TableCell>Ações</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {/* Caixa de pesquisa */}
                    <TableRow>
                        <TableCell colSpan={2}>
                            <TextField
                                label="Procurar Empregado"
                                variant="outlined"
                                fullWidth
                                value={searchTerm}
                                onChange={handleSearchChange}
                                sx={{ mb: 2 }}
                                placeholder="Procurar"
                            />
                        </TableCell>
                    </TableRow>

                    {empregados
                        .filter((empregado) =>
                            empregado.nome_completo.toLowerCase().includes(searchTerm.toLowerCase())
                        )
                        .map((empregado, index) => (
                            <TableRow
                                key={empregado.id}
                                sx={{
                                    backgroundColor: index % 2 === 0 ? 'white' : 'lightgrey', // Alterna entre branco e cinza claro
                                }}
                            >
                                <TableCell>{empregado.nome_completo}</TableCell>
                                <TableCell>
                                    <IconButton
                                        color="primary"
                                        onClick={() => handleOpenViewModal(empregado)}
                                    >
                                        <Visibility />
                                    </IconButton>
                                    <IconButton
                                        color="secondary"
                                        onClick={() => handleOpenAddModal(empregado)}
                                    >
                                        <Add />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
                </Paper>

                <Modal
    open={openViewModal}
    onClose={handleCloseModals}
    aria-labelledby="modal-view-horas-extras"
    aria-describedby="modal-view-horas-extras-description"
>
    <Box
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
        }}
    >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6">
                Horas Extras de {selectedEmpregado?.nome_completo}
            </Typography>
            <IconButton onClick={handleCloseModals}>
                <Close />
            </IconButton>
        </Box>
        
        <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={6}>
                <FormControl fullWidth>
                    <InputLabel id="select-mes-label">Mês</InputLabel>
                    <Select
                        labelId="select-mes-label"
                        value={selectedMes}
                        label="Mês"
                        onChange={handleMesChange}
                    >
                        {Array.from({ length: moment().month() + 1 }, (_, i) => i + 1).map((mes) => (
                            <MenuItem key={mes} value={mes}>
                                {moment(mes, 'M').format('MMMM')}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={6}>
                <FormControl fullWidth>
                    <InputLabel id="select-ano-label">Ano</InputLabel>
                    <Select
                        labelId="select-ano-label"
                        value={selectedAno}
                        label="Ano"
                        onChange={handleAnoChange}
                    >
                        <MenuItem value={moment().year()}>{moment().year()}</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </Grid>

        {/* TableContainer com scroll */}
        <TableContainer sx={{ maxHeight: 300, overflowY: 'auto' }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Data</TableCell>
                        <TableCell>Horas Trabalhadas</TableCell>
                        <TableCell>Justificação</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {horasExtras.length > 0 ? (
                        horasExtras.map((hora) => (
                            <TableRow key={hora.id}>
                                <TableCell>{moment(hora.data).format('DD/MM/YYYY')}</TableCell>
                                <TableCell>{hora.horas_trabalhadas} horas</TableCell>
                                <TableCell>{hora.justificativa || 'Não informada'}</TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={3} align="center">
                                Nenhuma hora extra registada para este período.
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>
</Modal>


                {/* Modal de Adição de Hora Extra */}
                <Modal
                    open={openAddModal}
                    onClose={handleCloseModals}
                    aria-labelledby="modal-add-hora-extra"
                    aria-describedby="modal-add-hora-extra-description"
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 400,
                            bgcolor: 'background.paper',
                            boxShadow: 24,
                            p: 4,
                            borderRadius: 2,
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                            <Typography variant="h6">
                                Adicionar Hora Extra para {selectedEmpregado?.nome_completo}
                            </Typography>
                            <IconButton onClick={handleCloseModals}>
                                <Close />
                            </IconButton>
                        </Box>
                        <TextField
                            label="Data"
                            type="date"
                            name="data"
                            fullWidth
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                            value={newHoraExtra.data}
                            onChange={handleNewHoraExtraChange}
                            inputProps={{
                                max: moment().format('YYYY-MM-DD'),
                            }}
                        />
                        <TextField
                            label="Horas Trabalhadas"
                            type="number"
                            name="horas_trabalhadas"
                            fullWidth
                            margin="normal"
                            InputProps={{ inputProps: { min: 0.5, step: 0.5 } }}
                            value={newHoraExtra.horas_trabalhadas}
                            onChange={handleNewHoraExtraChange}
                        />
                        <TextField
    style={{ display: 'none' }}  // Corrigido: style como objeto e chave 'display' entre chaves duplas
    label="Justificação"
    name="justificativa"
    fullWidth
    margin="normal"
    multiline
    rows={4}
    value={newHoraExtra.justificativa}
    onChange={handleNewHoraExtraChange}
/>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                            <Button variant="contained" color="primary" onClick={handleAddHoraExtra}>
                                Adicionar
                            </Button>
                        </Box>
                    </Box>
                </Modal>

                {/* Snackbar de Alertas */}
                <Snackbar
                    open={alert.open}
                    autoHideDuration={6000}
                    onClose={handleCloseAlert}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                    <Alert onClose={handleCloseAlert} severity={alert.severity} sx={{ width: '100%' }}>
                        {alert.message}
                    </Alert>
                </Snackbar>
            </Box>
        
    );
};

export default HorasExtraPage;
